/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/bloodGlucose',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '数据记录',
      icon: 'receiving',
    },
    children: [
      {
        path: '/bloodGlucose/bloodGlucose',
        component: () => import('@/myviews/DA_dataRecord/bloodGlucose/bloodGlucose'),
        alwaysShow: false,
        name: '血糖记录',
        meta: {
          title: '血糖记录',
          icon: 'message',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        }
      },
    ]
  },
  {
    path: '/dataRecord',
    notShow: true,
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '记录详情',
      icon: 'user',
    },
    children: [
      {
        path: '/dataRecord/recordDetails',
        component: () => import('@/myviews/DA_dataRecord/recordDetails/recordDetails'),
        alwaysShow: false,
        name: '记录详情',
        meta: {
          title: '记录详情',
          icon: 'user',
          roles: ['add', "modify", "viewpage"],//添加   修改   查看页面
          have: [],
        }
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/diabetesManage/AA_bloodGlucose.js